import { render, staticRenderFns } from "./coupon-list.vue?vue&type=template&id=21a6ab75&scoped=true&"
import script from "./coupon-list.vue?vue&type=script&lang=ts&"
export * from "./coupon-list.vue?vue&type=script&lang=ts&"
import style0 from "./coupon-list.vue?vue&type=style&index=0&id=21a6ab75&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6ab75",
  null
  
)

export default component.exports